export default __webpack_public_path__ + "img/b0683ec2fc46abd6cd55fe4fc436b8cf.png";